import { substringSearchFilter } from '@neptune/shared/search-business-logic';

export const defaultSearchEngine = substringSearchFilter;
